import client from "@/api/client"
import { useSession } from "next-auth/react"
import React, { ReactNode, useEffect, useState } from "react"

export const AccountContext = React.createContext<{
  user: any
  setAccountInfo: (data: any) => void
}>(null!)

export const AccountProvider = ({ children }: { children: ReactNode }) => {
  const { data: session } = useSession()
  const [accountInfo, setAccountInfo] = useState<any>()

  const loadUser = async () => {
    const response = await client.users
      .getUsers({
        // @ts-ignore
        query: {
          "populate[memberships][populate][group]": "id",
          "populate[picture]": "*",
        },
      })
      // A logged-in user with no membership in the resolved workspace
      // (e.g. on /workspace/join) gets a workspace_membership_required
      // 403 here. That's already handled by the axios interceptor
      // (redirect, or no-op if already on the join page) - just make
      // sure the rejection doesn't blow up as unhandled.
      // eslint-disable-next-line no-console
      .catch((error) => console.error(error))
    if (response) {
      setAccountInfo(response.data)
    }
  }

  useEffect(() => {
    if (session) {
      loadUser()
    }
  }, [session])

  return (
    <AccountContext.Provider value={{ user: accountInfo, setAccountInfo }}>
      {children}
    </AccountContext.Provider>
  )
}

export default AccountProvider
